import { useEffect, useState } from 'react';
import { useTranslation as useI18NextTranslation } from 'react-i18next';
import { useRootStore } from '#/hooks/useRootStore';
import { reaction } from 'mobx';

export const useTranslation = () => {
    const rootStore = useRootStore();
    const [namespace, setCurrentNamespace] = useState<string>(rootStore?.translationStore?.currentNamespace || 'nz');
    useEffect(
        () =>
            reaction(
                () => rootStore?.translationStore?.currentNamespace,
                (currentNamespace) => {
                    setCurrentNamespace(currentNamespace);
                }
            ),
        [rootStore?.translationStore?.currentNamespace]
    );

    return useI18NextTranslation(namespace);
};
